export const timeDefinition= {
  methods: {
    //初始化查询工作时间
   initWorkTable:function () {
     this.spinShow=true;
     let that=this;
     let param={
       journalType:"null",
       menuId:"null",
       pstnNumber:this.pstnNumber
     };
     this.$http.post("timeDefinition/toWorkDayIndex.json",param) .then(function (res) {
       let result=res.data.flag;
       that.spinShow=false;
       if(result!="666"){
         that.$alert(res.data.msg, '提示', {
           confirmButtonText: '确定'
         });
         return false;
       }
       let list=res.data.obj.workList;
       if (list.length==0){
         return false;
       }
       that.infoTableList=list;
       for (let i=0;i<that.infoTableList.length;i++){
         let oneTime=that.infoTableList[i].one.time;
         let twoTime=that.infoTableList[i].two.time;
         let threeTime=that.infoTableList[i].three.time;
         let fourTime=that.infoTableList[i].four.time;
         let fiveTime=that.infoTableList[i].five.time;
         let sixTime=that.infoTableList[i].six.time;
         let sevenTime=that.infoTableList[i].seven.time;
         if(oneTime){
           that.infoTableList[i].one.time=oneTime.split(",");
         }
         if(twoTime){
           that.infoTableList[i].two.time=twoTime.split(",");
         }
         if(threeTime){
           that.infoTableList[i].three.time=threeTime.split(",");
         }
         if(fourTime){
           that.infoTableList[i].four.time=fourTime.split(",");
         }
         if(fiveTime){
           that.infoTableList[i].five.time=fiveTime.split(",");
         }
         if(sixTime){
           that.infoTableList[i].six.time=sixTime.split(",");
         }
         if(sevenTime){
           that.infoTableList[i].seven.time=sevenTime.split(",");
         }
       }
       that.monday=list[0].one.isCheck=='0'?false:true;
       that.tuesday=list[0].two.isCheck=='0'?false:true;
       that.wednesday=list[0].three.isCheck=='0'?false:true;
       that.thursday=list[0].four.isCheck=='0'?false:true;
       that.friday=list[0].five.isCheck=='0'?false:true;
       that.saturday=list[0].six.isCheck=='0'?false:true;
       that.sunday=list[0].seven.isCheck=='0'?false:true;
     });
   },
    //初始化查询节假日
    initHolidayTable:function () {
      let that=this;
      let param={
        journalType:"null",
        menuId:"null",
        pstnNumber:this.pstnNumber
      };
      this.$http.post("timeDefinition/toHolidayIndex.json",param) .then(function (res) {
        let result=res.data.flag;
        if(result!="666"){
          that.$alert(res.data.msg, '提示', {
            confirmButtonText: '确定'
          });
          return false;
        }
        that.holidayList=res.data.obj.holidayList;
        that.singleCheckedList=[];
        that.checkedAll=false;
      });
    },
    cancel:function () {
      this.$emit("closePstnTime",false)
    },
    getArrValue:function(list,timeList,flag,content){
      if(!timeList && flag){
        return true;
      }
      if(flag && timeList){
        if(timeList[0]>timeList[1]){
          this.$alert("星期"+content+"的日期格式错误", '提示', {
            confirmButtonText: '确定'
          });
          return false;
        }
      }
      list.push(timeList.toString());
      return true;
    },
    //保存工作时间
    saveWorkTime:function () {
      let arrTwo=[]; let arrThree=[]; let arrFour=[]; let arrFive=[]; let arrSix=[]; let arrSeven=[]; let arrOne=[];
      for (let i=0;i<this.infoTableList.length;i++){
        let one=this.infoTableList[i].one.time;
        if(!this.getArrValue(arrTwo,one,this.monday,"一")){
          return false;
        }
        let two=this.infoTableList[i].two.time;
        if(!this.getArrValue(arrThree,two,this.tuesday,"二")){
          return false;
        }
        let three=this.infoTableList[i].three.time;
        if(!this.getArrValue(arrFour,three,this.wednesday,"三")){
          return false;
        }
        let four=this.infoTableList[i].four.time;
        if(!this.getArrValue(arrFive,four,this.thursday,"四")){
          return false;
        }
        let five=this.infoTableList[i].five.time;
        if(!this.getArrValue(arrSix,five,this.friday,"五")){
          return false;
        }
        let six=this.infoTableList[i].six.time;
        if(!this.getArrValue(arrSeven,six,this.saturday,"六")){
          return false;
        }
        let seven=this.infoTableList[i].seven.time;
        if(!this.getArrValue(arrOne,seven,this.sunday,"日")){
          return false;
        }
      }
      let param={
        journalType:"系统管理=>时间定义=>工作时间保存>",
        menuId:"3_6-1",
        weekdayOne:this.sunday?"1":"",//周末
        weekdayTwo:this.monday?'2':'',//周一
        weekdayThree:this.tuesday?'3':'',//周二
        weekdayFour:this.wednesday?'4':'',//周三
        weekdayFive:this.thursday?'5':'',//周四
        weekdaySix:this.friday?'6':'',//周五
        weekdaySeven:this.saturday?'7':'',//周六
        arrOne:arrOne.length>0?arrOne.toString():"",
        arrTwo:arrTwo.length>0?arrTwo.toString():"",
        arrThree:arrThree.length>0?arrThree.toString():"",
        arrFour:arrFour.length>0?arrFour.toString():"",
        arrFive:arrFive.length>0?arrFive.toString():"",
        arrSix:arrSix.length>0?arrSix.toString():"",
        arrSeven:arrSeven.length>0?arrSeven.toString():""
      };
      if(this.pstnNumber){
        param['pstnNumber']=this.pstnNumber;
      }else {
        param['updateFlag']=this.updateFlag;
      }
      let that=this;
      this.$http.post(this.saveWorkUrl,param) .then(function (res) {
        let result=res.data.flag;
        that.spinShow=false;
        if(result!="666"){
          that.$alert(res.data.msg, '提示', {
            confirmButtonText: '确定'
          });
          return false;
        }
        that.$Message.info(res.data.msg);
        that.initWorkTable();
      });
    },
    //删除工作时间
    deleteWorkTime:function (index) {
      this.infoTableList.splice(index,1);
    },
    //添加节假日时间
    addWorkTime:function () {
      let param={one:{time:''}, two:{time:''}, three:{time:''}, four:{time:''}, five:{time:''}, six:{time:''}, seven:{time:''}};
      this.infoTableList.unshift(param);
    },
    checkedAllList:function(){
      if (this.checkedAll){
        for (let i = 0; i < this.holidayList.length; i++) {
          let id=this.holidayList[i].id;
          this.singleCheckedList.push(id);
        }
        return false;
      }
      this.singleCheckedList=[];
    },
    //保存节假日
    saveHoliday:function(){
      if(this.starEndTime.length==0){
        this.$alert("时间不能为空", '提示', {
          confirmButtonText: '确定'
        });
        return false;
      }
      let startTime=this.starEndTime[0];
      let endTime=this.starEndTime[1];
      if(startTime>endTime){
        this.$alert("开始时间不能大于截止时间", '提示', {
          confirmButtonText: '确定'
        });
        return false;
      }
      if(startTime.length==19){
        startTime=startTime.substring(5,19);
        endTime=endTime.substring(5,19);
      }
      let param={
        journalType:"系统管理=>时间定义=>节假日添加",
        menuId:"3_6-2",
        startTime:startTime,
        endTime:endTime
      };
      if(this.pstnNumber){
        param['pstnNumber']=this.pstnNumber;
      }
      let that=this;
      this.$http.post(this.saveHolidayUrl,param) .then(function (res) {
        let result=res.data.flag;
        that.spinShow=false;
        if(result!="666"){
          that.$alert(res.data.msg, '提示', {
            confirmButtonText: '确定'
          });
          return false;
        }
        that.$Message.info(res.data.msg);
        that.initHolidayTable();
      });
    },
    //删除节假日
    deleteHoliday:function (id) {
      let that=this;
      let journalType = '系统管理=>时间定义=>节假日删除';
      let menuId = '3_6-3';
      if(!id){
        if(that.singleCheckedList.length==0){
            that.$Modal.info({
              title:'提示',
              content:'请选择删除的节假日数据'
          });
          return false;
        }
        journalType = '系统管理=>时间定义=>节假日批量删除';
        menuId='3_6-4';
        id=that.singleCheckedList.toString();
      }
      let param={
        journalType:journalType,
        menuId:menuId,
        ids:id
      };
      this.$Modal.confirm({
        title: '提示',
        content: "是否确定删除",
        onOk: () => {
          that.$http.post("timeDefinition/doHolidayDelete.json",param) .then(function (res) {
            let result=res.data.flag;
            if(result!="666"){
              that.$Modal.info({
                title:'提示',
                content:res.data.msg
              });
              return false;
            }
            that.$Message.info("节假日删除成功");
            that.initHolidayTable();
          })
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/js/TimeDefinition.js